import { Component, ViewChild, OnInit, Output, Input, HostListener, EventEmitter, ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { Repository } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';
import { Lists_nguonkinhphi, Lists_tinhchatnguonkp } from '../../../routes/menu'
import { Global, BaoCao } from '../../../shared/global';
import { ModalComponent } from 'ng2-bs3-modal/ng2-bs3-modal';
import 'jquery'
import 'bootstrap'


const swal = require('sweetalert');
@Component({
  selector: 'app-thamsobc-phieudieuchinhedit',
  templateUrl: './phieudieuchinhedit.component.html',
  //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./phieudieuchinhedit.component.scss'],
  providers: [ListService, Repository]
})


export class phieudieuchinheditComponent implements OnInit {


  msg: string;
  quyen_them: boolean = false;
  quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
  inputparents: any
  modalTitle: any;
  indLoading: boolean = false;
  doituongSelect: any = {
    Id: null, Tich_HienThiTungDongChiTiet: null, LyDoDieuChinh: null
    , SoPhieu: null
    , DonViId:null
  };
  nhomdtid: string = null;
  hoatdong: string = null;
  tabselected: number = 1;
  currentUser: any;

  @ViewChild('slCapTren', { static: false }) slCapTren: NgSelectComponent;
  @ViewChild('modaltuychinhmaubc', { static: false }) modaltuychinhmaubc: ModalComponent;
  @ViewChild('dtsuamaubaocao', { static: false }) dtsuamaubaocao: any;
  @Output() save: EventEmitter<any> = new EventEmitter();



  constructor(private _dataService: ListService, private repo: Repository) {


  }

  ngOnInit(): void {

  }
  comboSearchFn(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ma_Doi_Tuong.toLowerCase().indexOf(term) > -1 || item.Ten_Doi_Tuong.toLowerCase().indexOf(term) > -1;
  }
  @ViewChild("mafocus", { static: false }) mafocus: ElementRef;
  bnguonkinhphi: boolean = false;
  loaiphieu: number;
  loadDataInit(idchungtu: any, donviid: string, loaiphieu: number) {
    this.loaiphieu = loaiphieu;
    var authlogin = localStorage.getItem('currentUser');
    if (authlogin) {

      let data = JSON.parse(authlogin);
      this.currentUser = data;
      var giatri = data.ds_quyen.filter(name => name.id === idchungtu.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        this.modalTitle = giatri[0].ten_Phan_He;
        if (giatri[0].them == true)
          this.quyen_them = true;
        else
          this.quyen_them = false;
        if (giatri[0].sua == true)
          this.quyen_sua = true;
        else
          this.quyen_sua = false;
        if (giatri[0].xoa == true)
          this.quyen_xoa = true;
        else
          this.quyen_xoa = false;
      }
    }

    setTimeout(() => {
      this.mafocus.nativeElement.focus();
    }, 500);
    //this.repo.getRequest("api/doituong/getall2/" + nhomdoituongid + '/null/' + donviid)
    //  .subscribe(response => {
    //    this.inputparents = response;
    //  });
    this.doituongSelect = {
      Id: null, Tich_HienThiTungDongChiTiet: null, LyDoDieuChinh: null
      , SoPhieu: null
      , DonViId: null, ThongTinDieuChinh: null
    };
    this.doituongSelect.Id = idchungtu;
    this.doituongSelect.Tich_HienThiTungDongChiTiet = true;
    this.doituongSelect.DonViId = donviid;
    this.doituongSelect.ThongTinDieuChinh = 'điều chỉnh số liệu chi ngân sách.';
  }

  keyTenPress(event: any) {
    if (event.which === 13) {
      this.slCapTren.focus();
      event.preventDefault();
    }
  }
  public closeModal() {
    this.save.emit(null);
  }
  //public saveproduct() {

  //  this.repo.postRequest("api/doituong/addorupdate", this.doituongSelect)
  //    .subscribe(response => {
  //      console.log(response);
  //      this.doituongSelect.Id = response;
  //      this.save.emit(this.doituongSelect);
  //    });

  //}
  public tuychinhmaubaocao() {
    let id = BaoCao.BC08_07_PhieuDieuChinhSLNS_C2_10;
    if (this.loaiphieu == 1)
      id = "39AA557C-6A5D-43A7-9929-16C5568AE884";
    this.dtsuamaubaocao.loadDataInit(id);
    this.modaltuychinhmaubc.open();
  }
  public export(kieuin) {
    $('#loading').show();
    let id = BaoCao.BC08_07_PhieuDieuChinhSLNS_C2_10;
    if (this.loaiphieu == 1)
      id = "39AA557C-6A5D-43A7-9929-16C5568AE884";
    let data = {
      Id: id, // id cứng trong FunctionConstants để điều hướng đến hàm giay rút dự toán
      Type: kieuin,
      Data: JSON.stringify(this.doituongSelect)
    };
    if (kieuin === 'xlsx') {
      this.repo.postPdf(Global.BASE_BaoCao_SAVE, data)
        .subscribe(response => {
          $('#loading').hide();
          var file = new Blob([response.body], { type: 'vnd.ms-excel' });
          var fileURL = URL.createObjectURL(file);
          var a = document.createElement("a");
          a.href = fileURL;
          a.download = "phieu_dieu_chinh.xlsx";
          document.body.appendChild(a);
          a.click();

        });
    }
    if (kieuin === 'pdf') {
      this.repo.postPdf(Global.BASE_BaoCao_SAVE, data)
        .subscribe(response => {
          //console.log("tt");
          //console.log(response);
          if (response == "L") {
            $('#loading').hide();
            //this.repo.postRequest(Global.BASE_BaoCao_SAVE, data).subscribe(
            //  data => {
            //    $('#loading').hide();
            //  },
            //  error => {
            //    this.msg = error;
            //  }
            //);
          }
          else {
            $('#loading').hide();
            var file = new Blob([response.body], { type: 'application/pdf' });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL, "EPrescription");
          }

        });
    }
    


  }

  export_xml(loaiphieu) {
    //loaiphieu=1 giấy rút mẫu 02
    //loaiphieu=2 giấy rút mẫu 02b
    //loaiphieu=3 Bảng kê chứng từ thanh toán tạm ứng
    //loaiphieu=4 giấy đề nghị thanh toán tạm ứng
    //loaiphieu=5 ủy nhiệm chi
    $('#loading').show();
    let datatt = {
      Id: null,
      Type: null,
      Data: JSON.stringify({
        DonViId: this.currentUser.id_don_vi
        , UserName: this.currentUser.user_name
        , IdChungTu: this.doituongSelect.Id
        , LoaiPhieu: loaiphieu
        , Tich_HienChiTietCacButToan: this.doituongSelect.Tich_HienThiTungDongChiTiet
        , Tich_MaNguonNS: null


      })
    };


    this.repo.postRequest("api/baocao/ketnoikbnn/", datatt)
      .subscribe(response => {
        $('#loading').hide();
        if (response.TrangThai = "OK") {
          location.href = "/Logs/Reports/" + response.DuongDan;
        }
        else
          swal('Cảnh báo!', response.TrangThai, 'warning');
      });



  }





}
